/* tslint:disable:indent */

import {Field} from '../field';
import {SubGroup} from '../sub-group';
import {Section} from '../section';
import {SubSection} from '../sub-section';
import {Group} from '../group';
import {SubSubGroup} from '../sub-sub-group';
import {Notice} from '../notice';
import {MetaData} from '../meta.data';
import {LogService} from '../../../../shared/services/log.service';
import {SubSubSubGroup} from '../sub-sub-sub-group';
import { SubSubSubSubGroup } from '../sub-sub-sub-sub-group';

export class NoticeFactory {

  private static LOG: LogService = new LogService(NoticeFactory);

  private static fieldsToExpriment = [
    'OPT-300-Procedure-Buyer',
    'priorinformationnotice.contractingparty[].party.partyidentification[].id'
  ];

  private static fieldsToIgnoreByPath = [
    //'.listname',
    //'.unitcode'
  ];

  // ce paramètre sert à ignorer un champ par id
  private static fieldsToIgnore = [
    /*// E_FORM_16
    'BT-25-Lot',
    'BT-625-Lot',
    // E_FORM_1
    'BT-03-notice',
    'BT-02-notice',
    'BT-262-Procedure',
    'BT-26(m)-Procedure',
    'BT-263-Procedure',
    'BT-26(a)-Procedure'*/
  ];

  public static EFORM_PREFIX = '';


  public static createField(object: any): Field {
    if (this.fieldsToExpriment.includes(object.id)) {
      this.LOG.debug('');
    }
    const field: Field = {} as Field;
    field._label = object._label;
    field.contentType = object.contentType;
    field.description = object.description;
    field.displayType = object.displayType;
    field.id = object.id;
    field._identifierFieldId= object._identifierFieldId;
    field.formattedId = this.format(field.id);
    field._formattedLabel = this.format(field._label);
    field.jsonPath = object.jsonPath;
    field.codeList = object.codeList;
    field.conditions = object.conditions;
    field.legalType = object.legalType;
    field.type = object.type;
    field.pattern = object.pattern;
    field.maxLength = object.maxLength;
    field.mandatory = object.mandatory;
    field.forbidden = object.forbidden;
    field.forbiddenWithCondition = object.forbiddenWithCondition;
    field.forbiddenConditionV2 = object.forbiddenConditionV2;
    field.mandatoryWithCondition = object.mandatoryWithCondition;
    field.mandatoryConditionV2 = object.mandatoryConditionV2;
    field.defaultValue = object.defaultValue;
    field.defaultValueGroup = object.defaultValueGroup;
    field._idScheme = object._idScheme;
    field._idSchemes = object._idSchemes;
    field._schemeName = object._schemeName;
    field.placeHolder=object.placeholder;
    field.infoBulle=object.infoBulle;
    field.isJsonPathAlreadyUsed=object.isJsonPathAlreadyUsed;
    field.listname=object.listname;
    field._presetValue = object._presetValue;
    field.conditionsCreationMap = object.conditionsCreationMap;
    field.parcoursUtilisateur = object.parcoursUtilisateur;
    // dans le cas ou l'élément n a pas de jsonpath ou contient listname

    if (!field.jsonPath) {
      // field.jsonPath = 'error.nojsonpath.' + field.id;
      throw new Error('TO FIX');
    }

    // ici on triate les cas d'erreurs au niveau du jsonPath
    for (const index in this.fieldsToIgnoreByPath) {
      if (object.jsonPath.includes(this.fieldsToIgnoreByPath[index])) {
        // ici on va traiter l'ensemble des champs qui n'ont pas de jsonPath
        field.jsonPath = field.jsonPath.replace(this.fieldsToIgnoreByPath[index], '_error' + this.fieldsToIgnoreByPath[index]);
      }
    }


    field.ignore = false;
    // ce test est à retirer, il ne sert que à ignorer les jsonpath qui posent pb
    if (this.fieldsToIgnore.includes(field.id)) {
      field.ignore = true;
    }
    /*if (field.jsonPath !== undefined) {
      // TODO : enlever ce test ca sera systematique
      //field.value = this.getValue(noticeValue, field.jsonPath);
      this.LOG.debug('EFORMS_FIELD_FACT', field.jsonPath, field.id, field.value);
    }*/
    // tester les deux valeurs hidden et repeatable
    if (object._repeatable) {
      this.LOG.debug('FIELD_REP', field.id);
      field._repeatable = object._repeatable;
    } else {
      field._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('FIELD_HID', field.id);
      field.hidden = object.hidden;
    } else {
      field.hidden = false;
    }
    return field;
  }

  public static createSubGroup(object: any): SubGroup {
    const subgroup: SubGroup = {} as SubGroup;
    subgroup._label = this.EFORM_PREFIX + object._label;
    subgroup.contentType = object.contentType;
    subgroup.description = object.description;
    subgroup.displayType = object.displayType;
    subgroup._identifierFieldId= object._identifierFieldId;
    subgroup._idScheme = object._idScheme;
    subgroup.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    subgroup.conditions = object.conditions;
    subgroup.listname=object.listname;
    subgroup.conditionsCreationMap = object.conditionsCreationMap;
    subgroup.id = object.id;
    subgroup.defaultValue = object.defaultValue;
    subgroup.defaultValueGroup = object.defaultValueGroup;
    subgroup.formattedId = this.format(subgroup.id);
    subgroup._formattedLabel = this.format(subgroup._label);
    subgroup.fields = [];
    subgroup.subSubGroups = [];
    subgroup.parcoursUtilisateur = object.parcoursUtilisateur;
    if (object._repeatable) {
      this.LOG.debug('SUBG_REP', subgroup.id);
      subgroup._repeatable = object._repeatable;
    } else {
      subgroup._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('SUBG_HID', subgroup.id);
      subgroup.hidden = object.hidden;
    } else {
      subgroup.hidden = false;
    }
    subgroup.jsonPath = object.jsonPath;
    subgroup.infoBulle = object.infoBulle;
    return subgroup;
  }

  public static createSection(object: any): Section {
    const section: Section = {} as Section;
    // identification de la section
    section._label = this.EFORM_PREFIX + object._label;
    section.contentType = object.contentType;
    section.description = object.description;
    section.displayType = object.displayType;
    section.id = object.id;
    section._idScheme = object._idScheme;
    section._identifierFieldId= object._identifierFieldId;
    section.defaultValue = object.defaultValue;
    section.defaultValueGroup = object.defaultValueGroup;
    section.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    section.conditions = object.conditions;
    section.conditionsCreationMap = object.conditionsCreationMap;
    section.formattedId = this.format(section.id);
    section._formattedLabel = this.format(section._label);
    section.parcoursUtilisateur = object.parcoursUtilisateur;
    // le content de la section
    section.subsections = [];
    section.groups = [];
    section.fields = [];
    if (object._repeatable) {
      this.LOG.debug('SSECS_REP', section.id);
      section._repeatable = object._repeatable;
    } else {
      section._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('SEC_HID', section.id);
      section.hidden = object.hidden;
    } else {
      section.hidden = false;
    }
    section.baseId = section.id;
    section.index = object.index;
    section.jsonPath = object.jsonPath;
    return section;
  }

  public static createSubSection(object: any): SubSection {
    const subsection: SubSection = {} as SubSection;
    subsection._label = this.EFORM_PREFIX + object._label;
    subsection.contentType = object.contentType;
    subsection.description = object.description;
    subsection.displayType = object.displayType;
    subsection._idScheme = object._idScheme;
    subsection.listname=object.listname;
    subsection._identifierFieldId= object._identifierFieldId;
    subsection.id = object.id;
    subsection.defaultValue = object.defaultValue;
    subsection.defaultValueGroup = object.defaultValueGroup;
    subsection.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    subsection.conditions = object.conditions;
    subsection.conditionsCreationMap = object.conditionsCreationMap;
    subsection.formattedId = this.format(subsection.id);
    subsection._formattedLabel = this.format(subsection._label);
    subsection.groups = [];
    subsection.fields = [];
    subsection.parcoursUtilisateur = object.parcoursUtilisateur;
    if (object._repeatable) {
      this.LOG.debug('SUBS_REP', subsection.id);
      subsection._repeatable = object._repeatable;
    } else {
      subsection._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('SUBS_HID', subsection.id);
      subsection.hidden = object.hidden;
    } else {
      subsection.hidden = false;
    }
    subsection.jsonPath = object.jsonPath;
    return subsection;
  }


  public static createGroup(object: any): Group {
    const group: Group = {} as Group;
    group._label = this.EFORM_PREFIX + object._label;
    group.contentType = object.contentType;
    group.description = object.description;
    group.displayType = object.displayType;
    group.id = object.id;
    group.listname=object.listname;
    group._identifierFieldId= object._identifierFieldId;
    group.defaultValue = object.defaultValue;
    group.defaultValueGroup = object.defaultValueGroup;
    group.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    group.conditions = object.conditions;
    group.conditionsCreationMap = object.conditionsCreationMap;
    group.formattedId = this.format(group.id);
    group._formattedLabel = this.format(group._label);
    group._idScheme = object._idScheme;
    group.fields = [];
    group.subGroups = [];
    group.parcoursUtilisateur = object.parcoursUtilisateur;
    if (object._repeatable) {
      this.LOG.debug('GRP_REP', group.id);
      group._repeatable = object._repeatable;
    } else {
      group._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('GRP_HID', group.id);
      group.hidden = object.hidden;
    } else {
      group.hidden = false;
    }
    group.jsonPath = object.jsonPath;
    group.infoBulle = object.infoBulle;
    return group;
  }


  public static createSubSubgroup(object: any): SubSubGroup {
    const subSubgroup: SubSubGroup = {} as SubSubGroup;
    subSubgroup._label = this.EFORM_PREFIX + object._label;
    subSubgroup.contentType = object.contentType;
    subSubgroup.description = object.description;
    subSubgroup.displayType = object.displayType;
    subSubgroup.id = object.id;
    subSubgroup.listname=object.listname;
    subSubgroup._idScheme = object._idScheme;
    subSubgroup._identifierFieldId= object._identifierFieldId;
    subSubgroup.defaultValue = object.defaultValue;
    subSubgroup.defaultValueGroup = object.defaultValueGroup;
    subSubgroup.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    subSubgroup.conditions = object.conditions;
    subSubgroup.conditionsCreationMap = object.conditionsCreationMap;
    subSubgroup.formattedId = this.format(subSubgroup.id);
    subSubgroup._formattedLabel = this.format(subSubgroup._label);
    subSubgroup.fields = [];
    subSubgroup.subSubSubGroup = [];
    subSubgroup.parcoursUtilisateur = object.parcoursUtilisateur;
    if (object._repeatable) {
      this.LOG.debug('SUBSUBG_REP', subSubgroup.id);
      subSubgroup._repeatable = object._repeatable;
    } else {
      subSubgroup._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('SUBSUBG_HID', subSubgroup.id);
      subSubgroup.hidden = object.hidden;
    } else {
      subSubgroup.hidden = false;
    }
    subSubgroup.jsonPath = object.jsonPath;
    subSubgroup.infoBulle = object.infoBulle;
    return subSubgroup;
  }

  public static createSubSubSubgroup(object: any): SubSubSubGroup {
    const subSbSubgroup: SubSubSubGroup = {} as SubSubSubGroup;
    subSbSubgroup._label = this.EFORM_PREFIX + object._label;
    subSbSubgroup.contentType = object.contentType;
    subSbSubgroup.description = object.description;
    subSbSubgroup.displayType = object.displayType;
    subSbSubgroup.defaultValue = object.defaultValue;
    subSbSubgroup.listname=object.listname;
    subSbSubgroup._identifierFieldId= object._identifierFieldId;
    subSbSubgroup._idScheme = object._idScheme;
    subSbSubgroup.defaultValueGroup = object.defaultValueGroup;
    subSbSubgroup.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    subSbSubgroup.conditions = object.conditions;
    subSbSubgroup.conditionsCreationMap = object.conditionsCreationMap;
    subSbSubgroup.id = object.id;
    subSbSubgroup.formattedId = this.format(subSbSubgroup.id);
    subSbSubgroup._formattedLabel = this.format(subSbSubgroup._label);
    subSbSubgroup.fields = [];
    subSbSubgroup.subSubSubSubGroup = [];
    subSbSubgroup.parcoursUtilisateur = object.parcoursUtilisateur;
    if (object._repeatable) {
      this.LOG.debug('SUBSUBSUBG_REP', subSbSubgroup.id);
      subSbSubgroup._repeatable = object._repeatable;
    } else {
      subSbSubgroup._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('SUBSUBSUBG_HID', subSbSubgroup.id);
      subSbSubgroup.hidden = object.hidden;
    } else {
      subSbSubgroup.hidden = false;
    }
    subSbSubgroup.jsonPath = object.jsonPath;
    subSbSubgroup.infoBulle = object.infoBulle;
    return subSbSubgroup;
  }

  public static createSubSubSubSubgroup(object: any): SubSubSubSubGroup {
    const subSbSubSubgroup: SubSubSubGroup = {} as SubSubSubGroup;
    subSbSubSubgroup._label = this.EFORM_PREFIX + object._label;
    subSbSubSubgroup.contentType = object.contentType;
    subSbSubSubgroup.description = object.description;
    subSbSubSubgroup.displayType = object.displayType;
    subSbSubSubgroup.defaultValue = object.defaultValue;
    subSbSubSubgroup.listname=object.listname;
    subSbSubSubgroup._identifierFieldId= object._identifierFieldId;
    subSbSubSubgroup.defaultValueGroup = object.defaultValueGroup;
    subSbSubSubgroup.isJsonPathAlreadyUsed = object.isJsonPathAlreadyUsed;
    subSbSubSubgroup.conditions = object.conditions;
    subSbSubSubgroup.conditionsCreationMap = object.conditionsCreationMap;
    subSbSubSubgroup.id = object.id;
    subSbSubSubgroup.formattedId = this.format(subSbSubSubgroup.id);
    subSbSubSubgroup._formattedLabel = this.format(subSbSubSubgroup._label);
    subSbSubSubgroup.fields = [];
    subSbSubSubgroup.parcoursUtilisateur = object.parcoursUtilisateur;
    if (object._repeatable) {
      this.LOG.debug('SUBSUBSUBG_REP', subSbSubSubgroup.id);
      subSbSubSubgroup._repeatable = object._repeatable;
    } else {
      subSbSubSubgroup._repeatable = false;
    }
    if (object.hidden) {
      this.LOG.debug('SUBSUBSUBG_HID', subSbSubSubgroup.id);
      subSbSubSubgroup.hidden = object.hidden;
    } else {
      subSbSubSubgroup.hidden = false;
    }
    subSbSubSubgroup.jsonPath = object.jsonPath;
    subSbSubSubgroup.infoBulle = object.infoBulle;
    return subSbSubSubgroup;
  }

  public static createNotice(): Notice {
    const notice: Notice = {} as Notice;
    notice.metadata = {} as MetaData;
    notice.metadata.fields = [];
    notice.sections = [];
    return notice;
  }

  public static format(value: string): string {
    if(value != null){
      // @ts-ignore
      return value.replaceAll('|', '_pp_').replaceAll('-', '_dh_').replaceAll('(', '_pao_').replaceAll(')', '_paf_');
    }
   }


  public static deFormat(value: string): string {
    if(value != null){
      // @ts-ignore
      return value.replaceAll('_pp_', '|').replaceAll('_dh_', '-').replaceAll('_pao_', '(').replaceAll('_paf_', ')');

    }
  }
}
